import {
	amber,
	blueGrey,
	cyan,
	deepOrange,
	deepPurple,
	green,
	grey,
	lightBlue,
	lime,
	pink,
	red
} from '@mui/material/colors';
import { darkTheme, XYChartTheme } from '@visx/xychart';

export const XY_CHART_DARK_THEME: XYChartTheme = {
	...darkTheme,
	gridStyles: {
		stroke: grey[700],
		strokeOpacity: 0.3
	},
	colors: [deepPurple[400]]
};

export const XY_CHART_LIGHT_THEME: XYChartTheme = {
	...darkTheme,
	gridStyles: {
		stroke: grey[400],
		strokeOpacity: 0.2
	},
	colors: [deepPurple[400]]
};

export const XY_CHART_ERRORS_THEME: Partial<XYChartTheme> = {
	colors: [red[700]]
};

export const PIE_CHART_RANGE = [
	lightBlue.A200,
	lime[500],
	cyan[800],
	pink[500],
	deepPurple[400],
	deepOrange[600],
	blueGrey[400],
	green.A200,
	amber,
	red[900]
];
